import { render, staticRenderFns } from "./FlashCards.vue?vue&type=template&id=19bc77d2&scoped=true&"
import script from "./FlashCards.vue?vue&type=script&lang=js&"
export * from "./FlashCards.vue?vue&type=script&lang=js&"
import style0 from "./FlashCards.vue?vue&type=style&index=0&id=19bc77d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc77d2",
  null
  
)

export default component.exports